<template>
  <div :id="id" :class="{'d-none': !show}">
    <div v-if="pedido && pedido.id_pedido" style="font-family: sans-serif">
      <div class="text-center">
        <b class="h5 font-weight-bold mb-0">{{pedido.nome_empresa}}</b>
        <div>
          {{pedido.data_pedido}} - PDV: {{pedido.id_venda}}
        </div>
        <div v-if="pedido.atendente">Atendente: {{pedido.atendente}}</div>
        <hr>
        <b>#{{pedido.pedido}} - {{pedido.tipo}}</b>
        <div>**{{pedido | tipo_pedido}}**</div>
        <div v-if="pedido.obs_comanda">{{pedido.obs_comanda}}</div>
      </div>
      <hr>
      <div v-if="pedido.cliente">
        <b class="h6 font-weight-bold m-0">{{pedido.cliente.nome_cliente}}</b>
        <div v-if="pedido.cliente.endereco && pedido.tipo_pedido === '1'">
          {{pedido.cliente.endereco}}, {{pedido.cliente.numero}} - {{pedido.cliente.bairro}}
          <span v-if="pedido.cliente.complemento"> ({{pedido.cliente.complemento}})</span>
        </div>
        <div v-if="pedido.cliente.telefone"><b>Telefone: </b>
          <a :href="`https://wa.me/55${pedido.cliente.telefone}`" target="_blank">{{pedido.cliente.telefone | phone}}</a>
        </div>
        <hr>
      </div>
      <div v-for="p in pedido.itens" class="item" :data-cozinha="p.id_cozinha">
        <b v-if="showValor" class="right">{{p.valor_total | valor}}</b>
        <div v-if="!desmembrarImpressao || p.id_medida === '2' || (!p.divisao.length && !p.adicionais.length)" style="margin-top: 0.5rem">
          <b class="h6 font-weight-bold mb-0">
            <span v-if="p.id_medida === '2'">{{p.quantidade + 'kg'}}</span><span v-else>{{p.quantidade | qtd}}x</span> {{p.nome_produto}}
          </b>
          <div v-if="!desmembrarImpressao">
            <div v-for="d in p.divisao">
              # {{d.nome_produto}}
            </div>
            <div v-for="a in p.adicionais">
              + <span v-if="(a.quantidade / p.quantidade) > 1">{{(a.quantidade / p.quantidade) | qtd}}x</span> {{a.nome_produto}}<span v-if="showValor && a.valor > 0">: {{(a.valor * a.quantidade) | valor}}</span>
            </div>
          </div>
          <div v-if="p.observacao">Obs: <b>{{p.observacao}}</b></div>
        </div>
        <div v-else>
          <div style="margin-top: 0.5rem" v-for="i in parseInt(p.quantidade)">
            <b class="h6 font-weight-bold mb-0">1x {{p.nome_produto}}</b>
            <div>
              <div v-for="d in p.divisao">
                # {{d.nome_produto}}
              </div>
              <div v-for="a in p.adicionais">
                + <span v-if="(a.quantidade / p.quantidade) > 1">{{(a.quantidade / p.quantidade) | qtd}}x</span> {{a.nome_produto}}<span v-if="showValor && a.valor > 0">: {{(a.valor * a.quantidade) | valor}}</span>
              </div>
            </div>
            <div v-if="p.observacao">Obs: <b>{{p.observacao}}</b></div>
          </div>
        </div>
      </div>
      <div class="mt-2" v-if="pedido.obs_pedido">
        <div class="font-weight-bold">Observações do pedido:</div>
        - {{pedido.obs_pedido}}
      </div>
      <hr>
      <div v-if="pedido.tipo_comanda === '2'">
        <div v-if="pedido.pagamentos.length">
          Forma de pagamento
          <div v-for="p in pedido.pagamentos">
            <div class="right">{{p.valor | valor}}</div>
            <div>
              {{p.nome_pagamento}}<span class="small mr-2" v-if="p.observacao">: {{p.observacao}}</span>
            </div>
          </div>
          <hr>
        </div>
        <div>
          <div v-if="pedido.desconto && pedido.desconto > 0">
            <div class="right">(-) {{pedido.desconto | valor}}</div>
            <div>Desconto</div>
          </div>
          <div v-if="pedido.frete && pedido.frete > 0">
            <div class="right">(+) {{pedido.frete | valor}}</div>
            <div>Taxa de Entrega</div>
          </div>
          <div>
            <div class="right font-weight-bold">{{parseFloat(pedido.total_comanda) - parseFloat(pedido.desconto) | valor}}</div>
            <div class="font-weight-bold">Total</div>
          </div>
        </div>
        <div v-if="pedido.troco > 0">
          <hr>
          <div>
            <div class="right">{{(parseFloat(pedido.troco) + parseFloat(pedido.total_comanda) - parseFloat(pedido.desconto)) | valor}}</div>
            <div>Valor a receber do cliente</div>
          </div>
          <div>
            <div class="right">{{pedido.troco | valor}}</div>
            <div>Valor do Troco</div>
          </div>
        </div>
      </div>
      <div v-else-if="showValor">
        <div class="right">{{pedido.total | valor}}</div>
        <div>SubTotal</div>
      </div>
      <div class="text-center" v-if="pedido.tipo_comanda === '5'">
        <hr v-if="showValor">
        SENHA: {{(pedido.id_contador || '').slice(-2) }}
      </div>
      <div class="text-center font-weight-bold" v-if="pedido.tipo_comanda === '2'" style="text-align: center">
        <hr>
        www.lecard.delivery
      </div>
    </div>
    <component is="style">
      .right { float: right }
      .text-center { text-align: center; }
    </component>
  </div>
</template>

<script>
  export default {
    name: "CupomPedido",
    props: ['pedido','id','show'],

    filters: {
      qtd(value) {
        if (value !== null || value !== undefined) {
          return parseFloat(value).toFixed();
        }
      },

      phone(phone) {
        if (phone) {
          phone = phone.replace(/[^0-9]+/g,"");

          if (phone.length === 10) {
            return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');

          } else if (phone.length === 11) {
            return phone.replace(/[^0-9]/g, '')
                .replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
          }
        }

        return phone || '';
      },

      tipo_pedido(pedido) {
        switch (pedido.tipo_pedido) {
          case '1':
            return "ENTREGAR PEDIDO";
          case '2':
            return pedido.tipo_comanda === '2' ? "RETIRAR PEDIDO" : "PEDIDO PARA LEVAR";
          case '3':
            return "CONSUMIR NO LOCAL";
        }
      }
    },

    computed: {
      configs() {
        return this.$store.state.pdv.json_config;
      },

      desmembrarImpressao() {
        return this.configs.desmembrar_itens === '1';
      },

      showValor() {
        return (
            this.configs.show_valor === '1' || this.pedido?.tipo_comanda === '2'
        );
      }
    }
  }
</script>

<style scoped>
  .right {
    float: right;
  }
</style>
